import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/jdo/org/brx/deck/2025/layouts/default.vue").then(m => m.default || m))
}